var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#1BB934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6303 7.02647L17.6303 7.02646L17.6289 7.02782L9.85006 14.6981L6.37142 11.268C6.37136 11.268 6.37129 11.2679 6.37122 11.2678C6.2703 11.1676 6.13336 11.1116 5.99087 11.1116C5.84838 11.1116 5.71143 11.1676 5.6105 11.2679C5.61044 11.2679 5.61038 11.268 5.61031 11.268L5.03443 11.8359C5.03436 11.836 5.03428 11.836 5.03421 11.8361C4.93252 11.9357 4.875 12.0715 4.875 12.2136C4.875 12.3557 4.93254 12.4916 5.03425 12.5911C5.03431 12.5912 5.03437 12.5912 5.03443 12.5913L9.47362 16.9685C9.47368 16.9686 9.47373 16.9686 9.47379 16.9687C9.57471 17.0689 9.71167 17.125 9.85418 17.125C9.99668 17.125 10.1336 17.0689 10.2346 16.9687C10.2346 16.9686 10.2347 16.9686 10.2347 16.9685L18.9656 8.35957C18.9656 8.35951 18.9657 8.35946 18.9657 8.35941C19.0675 8.25984 19.125 8.12397 19.125 7.98186C19.125 7.83992 19.0676 7.70421 18.9661 7.60467C18.9659 7.6045 18.9657 7.60432 18.9656 7.60415L18.39 7.02845L18.39 7.02842L18.3879 7.02647C18.1767 6.82451 17.8416 6.82451 17.6303 7.02647Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f396434406634b29ba1a8944eabdb98b.svg";
export { ForwardRef as ReactComponent };